export default __webpack_public_path__ + "static/media/post.03f25a85.svg";